<template>
  <v-container fluid style="height: 100%;">
    <v-row>
      <v-col cols="12" align="left">
        <h3 style="font-weight: 500;">
          <v-icon :color="colorTheme">mdi-account</v-icon>Carriers
        </h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col lg="3" sm="4" cols="12" style="padding-bottom: 0; max-height: 60px;">
        <v-text-field
          solo
          :label="$t('search')"
          append-icon="mdi-magnify"
          single-line
          v-model="search"
          :color="colorTheme"
        ></v-text-field>
      </v-col>
      <v-col lg="2" md="3" sm="4" cols="12" style="padding-bottom: 0;">
        <v-btn
          style="width: 100%; margin: 0;"
          large
          :color="colorTheme"
          class="white--text"
          v-on:click="openAddCarrier()"
        >
          {{ $t("addCarrier").toUpperCase() }}
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
      <v-col lg="2" md="3" sm="4" cols="12" style="padding-bottom: 0;">
        <v-btn
          style="width: 100%; margin: 0;"
          large
          v-show="allCarriers.length > 0"
          :color="colorTheme"
          class="white--text"
          v-on:click="ConfirmCarriers()"
        >{{ $t("delete").toUpperCase() }}</v-btn>
      </v-col>
      <v-col lg="12" sm="12" md="12">
        <v-data-table
          :no-data-text="$t('noResults')"
          v-model="allCarriers"
          :headers="headersCarriers"
          :items="listCarriers"
          :search="search"
          show-select
          item-key="Id"
          :items-per-page="5"
          class="elevation-1"
          :loading="progressCa"
          :loading-text="$t('loadingTextForTable')"
          :footer-props="{
            'items-per-page-text': $t('rows'),
            'items-per-page-all-text': $t('all')
          }"
        >
          <template v-slot:item.TradeName="{ item }">
            <td
              style="display: table-footer-group; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.TradeName }}</td>
          </template>
          <template v-slot:item.BusinessName="{ item }">
            <td
              style="display: table-footer-group; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.BusinessName }}</td>
          </template>
          <template v-slot:item.DealerId="{ item }">
            <td
              style="display: table-footer-group; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.DealerId }}</td>
          </template>
          <template v-slot:item.ClientId="{ item }">
            <td
              style="display: table-footer-group; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.ClientId }}</td>
          </template>
          <template v-slot:item.AccountId="{ item }">
            <td
              style="display: table-footer-group; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.AccountId }}</td>
          </template>
          <template v-slot:item.Address="{ item }">
            <td
              style="display: table-footer-group; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.Address }}</td>
          </template>
          <template v-slot:item.ServiceType="{ item }">
            <td
              style="display: table-footer-group; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.ServiceType }}</td>
          </template>
          <template v-slot:item.Modality="{ item }">
            <td
              style="display: table-footer-group; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.Modality }}</td>
          </template>
          <template v-slot:item.act="{ item }">
            <td
              style="display: table-footer-group; padding: 8px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >
              <v-menu bottom left z-index="18" nudge-width="100">
                <template v-slot:activator="{ on }">
                  <v-btn :color="colorTheme" icon text v-on="on">
                    <v-icon v-show="item === selectedItem || visible == false">mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="item.Contacts.length > 0"
                    :color="colorTheme"
                    dense
                    v-on:click="viewContacts(item)"
                  >
                    <v-list-item-title>
                      {{
                      $t("seeContacts")
                      }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item :color="colorTheme" dense v-on:click="editCarrier(item)">
                    <v-list-item-title>{{ $t("edit") }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item :color="colorTheme" dense v-on:click="Confirm(item)">
                    <v-list-item-title>{{ $t("delete") }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </template>
          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
          >{{ $t("noResults") }} : "{{ search }}".</v-alert>
          <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t("of").toLowerCase()}} {{ items.itemsLength }} </template>
        </v-data-table>
      </v-col>
      <v-dialog v-model="confirm" hide-overlay persistent width="315">
        <v-card>
          <v-card-title
            class="headline"
            style="font-size: 14px !important;"
          >{{ $t("deleteConfirmCa") }}</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="padding-top: 11px;">
            {{
            carr.TradeName
            }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              :color="colorTheme"
              @click="confirm = false"
              v-on:click="confirmation(false)"
            >{{ $t("cancel").toUpperCase() }}</v-btn>
            <v-btn
              text
              :color="colorTheme"
              @click="confirm = false"
              v-on:click="confirmation(true)"
            >{{ $t("accept").toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="confirmCarriers" hide-overlay persistent width="421px">
        <v-card>
          <v-card-title class="headline" style="font-size: 14px !important;">
            {{
            $t("deleteAllCarriers")
            }}
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              :color="colorTheme"
              @click="confirmCarriers = false"
              v-on:click="confirmationCarrier(false)"
            >{{ $t("cancel").toUpperCase() }}</v-btn>
            <v-btn
              text
              :color="colorTheme"
              @click="confirmCarriers = false"
              v-on:click="confirmationCarrier(true)"
            >{{ $t("accept").toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="infoContacts" hide-overlay persistent width="421px">
        <v-toolbar dense flat>
          <v-toolbar-title>{{ contactsView.TradeName }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn v-on:click="CloseInfoContact()" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card>
          <v-progress-linear height="2" :color="colorTheme" v-model="valueDeterminate"></v-progress-linear>
          <v-list>
            <v-list-item v-for="item in contactsView.Contacts" :key="item.Id">
              <v-list-item-icon v-if="item.Type == 1">
                <v-icon :color="colorTheme">mdi-cellphone</v-icon>
              </v-list-item-icon>
              <v-list-item-icon v-if="item.Type == 2">
                <v-icon :color="colorTheme">mdi-email</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="text-left">
                {{
                item.Value
                }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
import moment from "moment";
export default {
  name: "carriers",
  data() {
    return {
      search: "",
      confirmCarrier: false,
      selectedItem: false,
      confirm: false,
      carr: [],
      confirmCarriers: false,
      infoContacts: false,
      contactsView: []
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.$store.commit("setTitle", this.$t("traffic"));
    this.$store.dispatch("getCarrierInfo");
    this.$store.commit("setPageHeader", [
      this.$t("carrierManagement"),
      "",
      "",
      "",
      true
    ]);
    this.$store.dispatch("ListofCariers");
  },
  computed: {
    ...mapState([
      "colorTheme",
      "headersCarriers",
      "listCarriers",
      "progressCa",
      "visible",
      "valueDeterminate"
    ]),
    allCarriers: {
      get: function() {
        return this.$store.state.allCarriers;
      },
      set: function(val) {
        this.$store.commit("allCarriers", val);
      }
    }
  },
  watch: {},
  methods: {
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem() {
      this.selectedItem = false;
    },
    editCarrier(val) {
      this.$store.dispatch("editObCarrier", val);
    },
    deleteCarrier(val) {
      this.$store.dispatch("DeleteCarrier", val);
    },
    openAddCarrier() {
      this.$router.push({ name: "addCarrier" });
    },
    ConfirmCarriers() {
      if (this.allCarriers.length > 0) {
        var offline = JSON.parse(localStorage.getItem("offline"));
        if (!offline) {
          this.confirmCarriers = true;
        } else {
          this.$store.commit("snackbar", {
            snackbar: true,
            text: i18n.t("later")
          });
        }
      } else {
        this.$store.commit("snackbar", {
          snackbar: true,
          text: i18n.t("noCarrier")
        });
      }
    },
    confirmationCarrier: function(val) {
      if (val) {
        this.$store.dispatch("DeleteAllCarriers", this.allCarriers);
      }
    },
    Confirm(val) {
      this.carr = val;
      this.confirm = true;
    },
    confirmation: function(val) {
      if (val) {
        this.$store.dispatch("DeleteCarrier", this.carr.Id);
      } else {
        this.carr = [];
      }
    },
    viewContacts(val) {
      this.infoContacts = true;
      this.contactsView = val;
      // console.log(this.contactsView);
    },
    CloseInfoContact() {
      this.infoContacts = false;
      this.contactsView = [];
    }
  }
};
</script>
